// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"24806":"e3ca36435cb7915e","48497":"589d8a59a4be3154","64885":"10cec4da7984f239"}[chunkId] + ".css";
};